import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import ProgressOverlay from "../common/components/ProgressOverlay.jsx";

const ProtectedRoute = ({ allowedPaths, children }) => {
	const location = useLocation();
	if (!allowedPaths || allowedPaths.length === 0) {
		return (
			<>
				<ProgressOverlay />
			</>
		);
	}
	const isAllowed = allowedPaths.some((path) =>
		location.pathname.startsWith(path)
	);
	if (!isAllowed) {
		return <Navigate to="/no-access" replace />;
	}
	return children;
};

export default ProtectedRoute;